import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import styled from 'styled-components'
export default (props) => (
  <StyledComponent>
    <USTemplateDefault
      location={props.location}
      lang="es"
      market="us"
      pageTitle="Deportes en vivo & on-demand"
      title={
        <>
          Deportes en vivo & <span className="text-nowrap">on-demand</span>
        </>
      }
      subtitle="Disfruta en tu TV, computadora o en cualquier otro dispositivo."
      networkSet="sports"
    />
  </StyledComponent>
)

const StyledComponent = styled.div`
  .text-nowrap {
    white-space: nowrap;
  }
`
